var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"background-color":"#2D2D2D","padding":"20px 0 20px 0"}},[_c('el-col',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"span":24}},[_c('img',{staticStyle:{"width":"100%","height":"205px"},attrs:{"loading":"lazy","src":require("../../assets/frame-02.png")}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21780d82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/advertisementTwo.vue
// module id = null
// module chunks = 